import { render, staticRenderFns } from "./BannerBlog.vue?vue&type=template&id=f6df19a0"
import script from "./BannerBlog.vue?vue&type=script&lang=js"
export * from "./BannerBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports